import { ref, computed, watch } from 'vue';

// Fuck yeah, global state
const mappedStorage = ref({});

export function createStorageNamespace(storageKey, defaultData = {}) {

  if (mappedStorage.value[storageKey] === undefined) {
    const raw = localStorage.getItem(storageKey);
    mappedStorage.value[storageKey] = raw ? JSON.parse(raw) : { ...defaultData };
  }

  const dataRef = ref(mappedStorage.value[storageKey]);

  function save() {
    localStorage.setItem(storageKey, JSON.stringify(dataRef.value));
  }

  watch(dataRef, save, { deep: true });

  return {
    get(key, defaultValue = undefined) {
      return key in dataRef.value ? dataRef.value[key] : defaultValue;
    },

    set(key, value) {
      dataRef.value[key] = value;
    },

    ref(key, defaultValue = undefined) {
      if (!(key in dataRef.value)) {
        dataRef.value[key] = defaultValue;
      }

      return computed({
        get() {
          return dataRef.value[key]
        },
        set: (val) => {
          dataRef.value[key] = val;
        },
      });
    },

    clear() {
      localStorage.removeItem(storageKey);
      dataRef.value = { ...defaultData };
    },
  };
}
